import { render, staticRenderFns } from "./Alarm.vue?vue&type=template&id=18241ed5&"
import script from "./Alarm.vue?vue&type=script&setup=true&lang=js&"
export * from "./Alarm.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports